import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiBriefcase, FiAward, FiCode, FiUsers } from 'react-icons/fi';
import './Experience.css';

const Experience = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const experiences = [
    {
      id: 1,
      type: 'work',
      icon: FiBriefcase,
      title: 'Insight360',
      company: 'ABB India Limited',
      period: 'August 2025 - November 2025',
      description: 'INSIGHT360 is a digital platform that automates engineering calculations, standardizes workflows, and provides real-time visibility to improve efficiency, accuracy, and compliance within ABB.',
      technologies: ['Power Apps', 'Power Automate', 'Sharepoint', 'Onedrive'],
      color: '#64ffda',
      image: 'https://res.cloudinary.com/djnqexy8g/image/upload/v1771155462/abb_hfhs7y.jpg', // Placeholder - Please replace with correct Cloudinary URL if needed
    },
    /*{
      id: 2,
      type: 'achievement',
      icon: FiAward,
      title: 'Best Project Award',
      company: 'College Technical Fest',
      period: 'Mar 2024',
      description: 'Won first place for developing an innovative student management system. Led a team of 3 developers and implemented modern web technologies for enhanced user experience.',
      technologies: ['React', 'Node.js', 'MongoDB', 'Express'],
      color: '#ff4a57',
    },
    {
      id: 3,
      type: 'work',
      icon: FiCode,
      title: 'Freelance Web Developer',
      company: 'Various Clients',
      period: 'Jan 2024 - Present',
      description: 'Built custom websites for local businesses and startups. Managed complete development lifecycle from requirements gathering to deployment and maintenance.',
      technologies: ['HTML', 'CSS', 'JavaScript', 'React', 'PHP'],
      color: '#64ffda',
    },
    {
      id: 4,
      type: 'achievement',
      icon: FiUsers,
      title: 'Technical Team Lead',
      company: 'College Computer Society',
      period: 'Sep 2023 - Present',
      description: 'Leading technical workshops and coding sessions for junior students. Organized hackathons and coding competitions, mentoring 20+ students in web development.',
      technologies: ['Leadership', 'Mentoring', 'Web Development', 'Event Management'],
      color: '#ff4a57',
    },
    {
      id: 5,
      type: 'achievement',
      icon: FiAward,
      title: 'Academic Excellence',
      company: 'Computer Engineering Department',
      period: 'Academic Year 2023-24',
      description: 'Achieved distinction in Computer Engineering with focus on software development, data structures, and web technologies. Completed advanced coursework in algorithms and system design.',
      technologies: ['Data Structures', 'Algorithms', 'Software Engineering', 'Database Systems'],
      color: '#ff4a57',
    },
    {
      id: 6,
      type: 'work',
      icon: FiBriefcase,
      title: 'Programming Tutor',
      company: 'College Learning Center',
      period: 'Aug 2023 - May 2024',
      description: 'Tutored junior students in programming fundamentals including C, C++, Java, and web development. Developed learning materials and conducted practical coding sessions.',
      technologies: ['C/C++', 'Java', 'HTML', 'CSS', 'JavaScript', 'Teaching'],
      color: '#64ffda',
    },*/
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section id="experience" className="experience section">
      <div className="container">
        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <motion.h2 className="section-title" variants={itemVariants}>
            Experience
          </motion.h2>

          <div className="experience-container">
            {experiences.map((exp) => (
              <motion.div
                key={exp.id}
                className="featured-experience-card"
                variants={itemVariants}
                whileHover={{ y: -5 }}
              >
                <div className="experience-content-wrapper">
                  <div className="experience-text-content">
                    <div className="experience-header">
                      <div className="company-info">
                        <h3 className="company-name">{exp.company}</h3>
                        <h4 className="experience-role">{exp.title}</h4>
                      </div>
                      <div className="experience-meta">
                        <span className="experience-period">{exp.period}</span>
                        <div className="experience-location">Nashik, Maharashtra</div>
                      </div>
                    </div>

                    <div className="experience-body">
                      <p className="experience-description">{exp.description}</p>

                      <ul className="experience-highlights">
                        <li>Automated engineering calculations and standardized workflows.</li>
                        <li>Provided real-time visibility to improve efficiency and accuracy.</li>
                        <li>Ensured compliance with industry standards within ABB.</li>
                      </ul>
                    </div>

                    <div className="experience-footer">
                      <div className="experience-technologies">
                        {exp.technologies.map((tech, techIndex) => (
                          <span key={techIndex} className="tech-pill">
                            {tech}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="experience-image-container">
                    <div className="experience-image-frame">
                      <img
                        src={exp.image}
                        alt={`${exp.company} Experience`}
                        className="experience-image"
                      />
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/*<motion.div className="experience-summary" variants={itemVariants}>
            <div className="summary-stats">
              <div className="summary-stat">
                <span className="stat-number">6+</span>
                <span className="stat-label">Experiences</span>
              </div>
              <div className="summary-stat">
                <span className="stat-number">2</span>
                <span className="stat-label">Internships</span>
              </div>
              <div className="summary-stat">
                <span className="stat-number">3+</span>
                <span className="stat-label">Awards</span>
              </div>
              <div className="summary-stat">
                <span className="stat-number">20+</span>
                <span className="stat-label">Students Mentored</span>
              </div>
            </div>
          </motion.div>*/}
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;